import React from "react";

function initialsFrom(name = "") {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0])
        .join("")
        .toUpperCase() || "?";
}

export function InitialsAvatar({ name, initials, size = 32, className = "" }) {
    const label = initials || initialsFrom(name);
    const s = { width: size, height: size, fontSize: Math.round(size * 0.42) };
    // deterministic cool tint from string — navy / green / red / yellow families
    const hash = [...(name || label)].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 0);
    const palettes = [
        { bg: "#F1F4FB", fg: "#1B3D7A" }, // navy
        { bg: "#EBF3EE", fg: "#1F6F47" }, // green
        { bg: "#FEF6E1", fg: "#B58611" }, // yellow
        { bg: "#FBEBEA", fg: "#C8342D" }, // red
        { bg: "#E7EAEF", fg: "#2C3542" }, // grey
    ];
    const p = palettes[hash % palettes.length];
    return (
        <div
            className={`inline-flex items-center justify-center rounded-full font-bold ${className}`}
            style={{
                ...s,
                background: p.bg,
                color: p.fg,
                fontFamily: "Inter, sans-serif",
                letterSpacing: "-0.02em",
            }}
        >
            {label.slice(0, 2)}
        </div>
    );
}
